// data/faqData.js
export const FAQ_ITEMS = [
  {
    id: 1,
    question: "How do I post a new job listing?",
    answer: (
      <>
        Navigate to <strong>My Jobs</strong> in the sidebar and click{" "}
        <strong>Post a Job</strong>. Fill in the job title, description,
        requirements, and salary range. Your listing goes live immediately after
        submission and can be edited at any time.
      </>
    ),
  },
  {
    id: 2,
    question: "How do I upgrade or change my subscription plan?",
    answer: (
      <>
        Go to <strong>Subscription &amp; Payment</strong> in the sidebar. You'll
        see your current plan and all available options. Click{" "}
        <strong>Upgrade Plan</strong> and follow the secure checkout flow.
        Changes take effect immediately.
      </>
    ),
  },
  {
    id: 3,
    question: "Why is my company profile showing as unverified?",
    answer: (
      <>
        Verification is a manual review process. Ensure your company profile is
        fully complete — including logo, description, and contact details. Our
        team typically reviews submissions within 1–2 business days. You'll be
        notified by email once verified.
      </>
    ),
  },
  {
    id: 4,
    question: "How do I reset my account password?",
    answer: (
      <>
        Click <strong>Forgot password?</strong> on the login screen and enter
        your email address. You'll receive a reset link within a few minutes. If
        you're already logged in, you can change your password from{" "}
        <strong>My Profile → Security</strong>.
      </>
    ),
  },
  {
    id: 5,
    question: "Can I invite team members to manage jobs together?",
    answer: (
      <>
        Yes! Head to <strong>Team Management</strong> in the sidebar. You can
        invite colleagues by email and assign them roles — Admin, Hiring
        Manager, or Viewer. Team members on paid plans can collaborate on job
        listings and applicant reviews.
      </>
    ),
  },
  {
    id: 6,
    question: "How long does it take to get a response from support?",
    answer: (
      <>
        Email support typically responds within <strong>4–8 hours</strong> on
        business days. Live chat (available on Pro and Enterprise plans) usually
        connects you within a few minutes. Critical issues are escalated and
        addressed within 1 hour.
      </>
    ),
  },
  {
    id: 7,
    question: "How do I cancel my subscription?",
    answer: (
      <>
        You can cancel anytime from{" "}
        <strong>
          Subscription &amp; Payment → Manage Plan → Cancel Subscription
        </strong>
        . Your account stays active until the end of the current billing period.
        No partial refunds are issued for unused time.
      </>
    ),
  },
  {
    id: 8,
    question: "Is my company data safe on Awasource?",
    // `hasContactLink` tells FaqList to render a real button (wired to the Contact modal)
    // in place of the trailing "contacting support" link.
    answer: (
      <>
        Absolutely. All data is encrypted in transit (TLS 1.3) and at rest
        (AES-256). We never sell your data to third parties. You can request a
        full data export or account deletion at any time by{" "}
      </>
    ),
    hasContactLink: true,
  },
];
